import React, { useState } from 'react';
import type { FC } from 'react';
import { ChooseCodeIdentifier } from './ChooseCodeIdentifier.js';
import { ChooseNamespace } from './ChooseNamespace.js';

export const PostAppRegistration: FC<{
  onPostRegistrationComplete: (data: {
    namespace: string;
    codeIdentifier: string;
  }) => void;
  appId: string;
  packageName: string;
}> = ({ appId, packageName, onPostRegistrationComplete }) => {
  const [namespace, setNamespace] = useState<string>();

  return (
    <>
      {
        <ChooseNamespace
          appId={appId}
          packageName={packageName}
          onSubmit={setNamespace}
        />
      }
      {namespace && (
        <ChooseCodeIdentifier
          appId={appId}
          packageName={packageName}
          onSubmit={(codeIdentifier) =>
            onPostRegistrationComplete({
              namespace,
              codeIdentifier,
            })
          }
        />
      )}
    </>
  );
};
